import { useEffect, useState } from "react";

export function useAnnouncementStatus(currentVersion?: string) {
  const [hasNewAnnouncements, setHasNewAnnouncements] = useState(false);

  useEffect(() => {
    if (!currentVersion) {
      setHasNewAnnouncements(false);
      return;
    }

    const checkStatus = () => {
      const lastSeenVersion = localStorage.getItem("announcements_last_seen_version");
      const hasNew = !lastSeenVersion || lastSeenVersion !== currentVersion;
      setHasNewAnnouncements(hasNew);
    };

    // Verificación inicial
    checkStatus();

    // Crear un custom event para detectar cuando se marca como visto
    const handleAnnouncementSeen = () => {
      checkStatus();
    };

    document.addEventListener("announcementsSeen", handleAnnouncementSeen);

    return () => {
      document.removeEventListener("announcementsSeen", handleAnnouncementSeen);
    };
  }, [currentVersion]);

  return hasNewAnnouncements;
}